"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.posthogCapture = void 0;
var _constants = require("../constants.js");
var _ravenJs = _interopRequireDefault(require("raven-js"));
var _posthogJs = _interopRequireDefault(require("posthog-js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var posthogCapture = exports.posthogCapture = function posthogCapture() {
  if (!_constants.POSTHOG_API_KEY) {
    return;
  }
  for (var _len = arguments.length, posthogArgs = new Array(_len), _key = 0; _key < _len; _key++) {
    posthogArgs[_key] = arguments[_key];
  }
  try {
    _posthogJs["default"].capture.apply(_posthogJs["default"], posthogArgs);
  } catch (err) {
    _ravenJs["default"].captureException(err, {
      extra: posthogArgs
    });
  }
};
//# sourceMappingURL=posthog-utils.js.map